<template>
<!-- TODO:有点击bug -->
    <div class="news-header">
       <div class="news-main flex-align-between">
           <ul class="nav-left flex-align">
               <!-- <li>未来教师研修学院</li> -->
                <li><a href="/" rel="noopener noreferrer"><img src="../../../assets/logo.png" alt=""></a></li>
                <!-- <li><a href="javaScript:;" target="_blank" rel="noopener noreferrer"></a></li> -->
                <!-- <li><a href="javaScript:;" target="_blank" rel="noopener noreferrer"></a></li> -->
            </ul>
            <ul class="nav-right flex-align">
                <li v-for="(nav, index) in navs" 
                    :key="index" 
                    :class="{active: ( isActive === index && isActive !== null  )}"
                    @mouseleave="mouseLeave(index)"
                    @mouseenter="mouseEnter(index)"
                    @click="gotoPage(index,nav)">
                    <!-- <router-link :to="nav.href" >{{nav.name}}</router-link> -->
                   {{nav.name}}
                </li>
                <!-- <li><router-link to="/home">返回主页</router-link></li>
                <li><router-link to="/home">返回主页</router-link></li>
                <li><router-link to="/home">返回主页</router-link></li> -->
                <!-- <li @click="$router.push('/home')">返回主页</li> -->
            </ul>
       </div>
    </div>
</template>

<script>
export default {
    props: {
        page: {
            type:Number,
            default:null,
        }
    },
    data() {
        return {
            isActive:0,
            currentPage:0,
            timer:null,
            navs:[{
                name:'首页',
                href:'/home'
            },{
                name:'工作动态',
                href:'/list/course'
            },{
                name:'教育资讯',
                href:'/list/information'
            },{
                name:'学术动态',
                href:'/list/learning'
            },{
                name:'实验区风采',
                href:'/list/elegant'
            },{
                name:'特色项目',
                href:'/project'
               
            },{
                name:'实验区名录',
                href:'/experiment_list'
            }
            
            ]
        }
    },

    methods: {
        gotoPage(index,nav){
            this.$nextTick(function(){
                this.$router.push(nav.href)
            })
            
        },
         //   鼠标移入
         mouseEnter(index) {
             this.isActive = index;
         },
        //   鼠标移除
         mouseLeave(index) {
            this.isActive = this.page;
         },
    },
     mounted: function() {
            this.isActive = this.page;
     },
    //  updated: function() {
    //     this.currentPage = this.page;
    //  }
    
}
</script>

<style lang="less" scoped>
    .news-header {
        height: 84px;
        font-size: 16px;
        // background-color: #1c4b90;
        background-image: linear-gradient(to bottom,#1c4b90,#1352b0);;
    }

    .news-main {
        box-sizing: border-box;
        margin: 0 auto;
        padding: 20px 28px 0 33px;
        width: 1200px;
    }

    .nav-left {
        li {
            // margin-right: 19px;
            cursor: auto;
            color: #fff;
            // &:first-child {
            //     margin-right: 29px;
            // }

            // &:last-child a{
            //     border-left: 1px solid #fff;
            //     padding-left:18px;
            // }

            a img{
                width: 251px;
                vertical-align: text-bottom;
            }
        }
        
    }

    .nav-right {
        li {
            padding: 0 29px;
            line-height: 64px;

            color: #fff;
            // background-color: #1c4b90;
            
            cursor: pointer;
            // user-select: none; 
            // &:last-child {
            //     padding: 0 0 0 19px;
                
            //     // a {   
            //         display: block; 
            //         font-size: 12px;
            //         color: #3cf;
            //     // }  
            // }
        }

        .active{
            color: #1c4b90;
            background-color: #fff;
        }
    }

    a {
        display: block;
        line-height: 64px;
        color: #fff;
    }
</style>